import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6317b967"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_total" }
const _hoisted_4 = { class: "content_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "content_list_item_name" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"#03AF76"}
}
const _hoisted_8 = {
  key: 1,
  style: {"color":"#305ED5"}
}
const _hoisted_9 = {
  key: 2,
  style: {"color":"#F5A400"}
}
const _hoisted_10 = {
  key: 3,
  style: {"color":"red"}
}

import { onMounted, ref, reactive } from 'vue'
    import { checkAllList, warehouseList } from '@/apis/WorkOrderAPI'
    import { model } from '@/interface'
    import { judgmentPlatform } from "@/utils/utils"
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    // 搜索数据接口
    interface form extends model {
        total: number,
        name: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        },
        systemDicDataId: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '100%'
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        name: '',
    })

    // 搜索分类标签
    let tagList = ref<Array<{id: string, name: string, num: string}>>([])

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)
    let isOne = ref<boolean>(true)

    // 搜索框
    const searchInput = (data: any) => {
        form.page = 0
        finished.value = false
        list.value = []
        form.name = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any) => {
        emit('value', item)
    }

    // 获取工单列表数据
    const onLoad = async () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            warehouseList({
                capacity: form.capacity,
                page: form.page,
                model: {
                    systemDicDataId: props.systemDicDataId,
                    name: form.name,
                    status: 1
                }
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    form.total = res.data.total
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad()
    }

    let status = ref<boolean>(false)

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    position: "bottom",
    style: _normalizeStyle({ height: props.height })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
        }, [
          _createVNode(vSearch, {
            onSearchInput: searchInput,
            onSubmit: submit,
            isShow: false,
            placeholder: "搜索仓库名称"
          })
        ], 2),
        _createElementVNode("div", _hoisted_3, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content_list_item",
                      key: i,
                      onClick: ($event: any) => (jump(item))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (item.tmodel.label == 'APPLIANCE_ONTEST')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "[" + _toDisplayString(item.tmodel.code) + "]", 1))
                          : _createCommentVNode("", true),
                        (item.tmodel.label == 'APPLIANCE_MIX')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[" + _toDisplayString(item.tmodel.code) + "]", 1))
                          : _createCommentVNode("", true),
                        (item.tmodel.label == 'APPLIANCE_OFFTEST')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "[" + _toDisplayString(item.tmodel.code) + "]", 1))
                          : _createCommentVNode("", true),
                        (item.tmodel.label == 'APPLIANCE_USELESS')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "[" + _toDisplayString(item.tmodel.code) + "]", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ])
                    ], 8, _hoisted_5))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show", "style"]))
}
}

})